const COOKIE_OPTIONS = {
	path: "/",
	maxAge: 60 * 60 * 24 * 120, // 120 days
};

export function setLocaleCookie(locale: string) {
	const cookieNames = ["app_locale", "i18n_locale", "i18n_redirected"];

	cookieNames.forEach((name) => {
		const cookie = useCookie(name, COOKIE_OPTIONS);
		cookie.value = locale;
	});
}

export function getLocaleCookie(): string | undefined {
	return useCookie("app_locale").value;
}